export default [
  {
    path: '/subscription-plan/list',
    name: 'subscription-plan-list',
    component: () => import('@/views/subscription-plan/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Subscription Plan',
      requiresFeature: 'enableSubscriptions',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Subscription' }, { title: 'Subscription Plan', active: true }]
    }
  }
]
